module.exports = __webpack_public_path__ + "static/img/dagang-logo-redesign-04@2x.9473ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/dagang-logo-redesign-04@2x.png
// module id = /+Z/
// module chunks = 18